var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "verification-code-container"
  }, [_c('input', {
    ref: "hiddenInput",
    staticClass: "hidden-code-input",
    attrs: {
      "type": "tel",
      "autocomplete": "one-time-code",
      "autocorrect": "off",
      "autocapitalize": "off"
    },
    on: {
      "input": _vm.handleHiddenInput,
      "focus": _vm.handleHiddenFocus
    }
  }), _c('div', {
    staticClass: "code-input-wrapper"
  }, _vm._l(_vm.codeLength, function (item, index) {
    return _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.codeArray[index],
        expression: "codeArray[index]"
      }],
      key: index,
      ref: "codeInputs",
      refInFor: true,
      class: ['code-input', {
        active: _vm.currentFocus === index
      }],
      attrs: {
        "type": "text",
        "maxlength": "1",
        "inputmode": "numeric",
        "pattern": "[0-9]*"
      },
      domProps: {
        "value": _vm.codeArray[index]
      },
      on: {
        "input": [function ($event) {
          if ($event.target.composing) return;
          _vm.$set(_vm.codeArray, index, $event.target.value);
        }, function ($event) {
          return _vm.handleInput(index, $event);
        }],
        "keydown": function ($event) {
          return _vm.handleKeydown(index, $event);
        },
        "focus": function ($event) {
          return _vm.handleFocus(index);
        },
        "paste": _vm.handlePaste
      }
    });
  }), 0), _c('div', {
    staticClass: "tip-text"
  }, [_vm._v(` ${$t("c9yo5l7", "未收到验证码?")} `), _vm.countdown > 0 ? _c('span', {
    staticClass: "resend-btn disabled"
  }, [_vm._v(` ${$t("px5sja6", "重新获取 (")}` + _vm._s(_vm.countdown) + "s) ")]) : _vm.hasSent ? _c('span', {
    staticClass: "resend-btn active",
    on: {
      "click": _vm.handleResend
    }
  }, [_vm._v(` ${$t("itjzk24", "重新获取")} `)]) : _c('span', {
    staticClass: "resend-btn active",
    on: {
      "click": _vm.handleResend
    }
  }, [_vm._v(` ${$t("t09mz15", "获取验证码")} `)])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };